export default __webpack_public_path__ + "static/media/Magda Sgarella.e52a5b0f.jpg";